// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-bv0Xmc","tooltip":"tooltip-TBelXm"};